<header class="background-header">
    <img src="../../assets/img/{{themeService.theme}}/header-background.svg" alt="" class="background-header-img"
        [ngClass]="{backgroundWidth: themeService.theme == 'white-label' || themeService.theme == 'life-file'}">
</header>

<section class="main-side-nav"
    [ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme == 'white-label' || themeService.theme == 'life-file'}">
    <section class="add-clients-container container">
        <app-steps-header [step1]="'Add Client'" [step2]="'Review'" [step3]="'Create'" [isStep1Active]="true"
            [isStep2Active]="true" [isStep3Active]="true">
        </app-steps-header>
        <section class="template-section-title">
            <div class="title-container">
                <h1>Zenplans Professional</h1>
            </div>
        </section>

        <section class="add-client-container">
            <section class="dynamic-collapse">
                <img src="../../../assets/img/{{themeService.theme}}/delegate.svg" alt="Created Account Img" width="120">
                <div class="title">Account created!</div>
                <div class="content">
                    Head to your Shared Plans menu to pre-populate your client’s Zenplan.
                    Once it’s ready to share you can send them an email nudge to invite them to view it.
                </div>
                <input *ngIf="accountType=='invite-only'" type="button" value="Tailor Their Zenplan" class="return-home" (click)="returnHome()">
                <input *ngIf="accountType=='upload-professionals-list'" type="button" value="Return Home" class="return-home" (click)="returnHome()">
            </section>
        </section>
    </section>
</section>
<p>account-created works!</p>